/* StylishRugs luxury runtime (v51) — extracted from inline <script> in layout/theme.liquid (v50).
   Behaviors: product LCP image upgrade, fade-in IntersectionObserver, subscription warning scrub,
   review count fix (87 -> 170+), fake testimonial removal, review-stars ARIA labelling.
   Loaded with defer so it executes after HTML parse without blocking render. */
(function () {
  'use strict';

  function upgradeProductLcpImg() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    /* v145: the sr gallery sets eager/high on the slide actually shown (server-side); promoting the
       first image too gave two high-priority images when ?variant= opens on another slide. */
    if (document.querySelector('.sr-product__slide')) return;
    var candidates = document.querySelectorAll('.product__media-item:first-child img, .product__media:first-of-type img, [data-media-id]:first-of-type img, .product-single__media img');
    var first = candidates[0];
    if (!first) {
      var scope = document.querySelector('.product, .product-single, main');
      if (scope) first = scope.querySelector('img');
    }
    if (first) {
      try {
        first.setAttribute('loading', 'eager');
        first.setAttribute('fetchpriority', 'high');
        first.removeAttribute('data-load');
      } catch (e) {}
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });
    var observe = function () {
      document.querySelectorAll('[data-fade]:not(.is-visible)').forEach(function (el) { io.observe(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
    else observe();
    window.addEventListener('shopify:section:load', observe);
    window.addEventListener('cart:updated', observe);
  }

  function scrubSubscriptionWarnings() {
    var phrases = ['deferred, subscription, or recurring purchase', 'deferred or recurring', 'subscription, or recurring', 'selling_plan'];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node, kill = [];
    while ((node = walker.nextNode())) {
      var txt = (node.nodeValue || '').toLowerCase();
      for (var i = 0; i < phrases.length; i++) {
        if (txt.indexOf(phrases[i]) !== -1) { kill.push(node); break; }
      }
    }
    kill.forEach(function (n) {
      var p = n.parentElement;
      while (p && p !== document.body) {
        if (p.matches('.cart-warning, .cart__warnings, [data-cart-warnings], li, div, p, span')) { p.style.display = 'none'; break; }
        p = p.parentElement;
      }
    });
  }

  function fixReviewCount() {
    var REGEX = /\b87(\s+(?:customer\s+)?reviews?)/gi;
    var REPLACEMENT = '170+$1';
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && REGEX.test(node.nodeValue)) {
        REGEX.lastIndex = 0;
        node.nodeValue = node.nodeValue.replace(REGEX, REPLACEMENT);
      }
    }
  }

  function hideFakeTestimonials() {
    var FAKE_AUTHORS = ['Sarah M., Sacramento', 'Daniel R., Roseville'];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node, kill = [];
    while ((node = walker.nextNode())) {
      var txt = node.nodeValue || '';
      for (var i = 0; i < FAKE_AUTHORS.length; i++) {
        if (txt.indexOf(FAKE_AUTHORS[i]) !== -1) { kill.push(node); break; }
      }
    }
    kill.forEach(function (n) {
      var p = n.parentElement;
      var card = null;
      while (p && p !== document.body) {
        if (p.matches('blockquote, article, li, [class*="testimonial"], [class*="review-card"], [class*="customer-review"], [class*="review-item"]')) {
          card = p; break;
        }
        p = p.parentElement;
      }
      if (card) card.style.display = 'none';
      else if (n.parentElement) n.parentElement.style.display = 'none';
    });
  }

  function fixReviewStarsAria() {
    document.querySelectorAll('.sr-reviews-block__stars, .judgeme-stars, [class*="review-stars"], [class*="rating-stars"]').forEach(function (el) {
      if (el.hasAttribute('role') && el.hasAttribute('aria-label')) return;
      var txt = (el.textContent || '').trim();
      var ratingMatch = txt.match(/([\d.]+)\s*(?:\/|out of)\s*5/i);
      var label;
      if (ratingMatch) {
        label = 'Rated ' + ratingMatch[1] + ' out of 5';
      } else {
        var dataRating = el.getAttribute('data-rating') || el.getAttribute('data-score');
        label = dataRating ? 'Rated ' + dataRating + ' out of 5' : 'Customer star rating';
      }
      if (!el.hasAttribute('role')) el.setAttribute('role', 'img');
      if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', label);
    });
  }

  function runAllScrubbers() {
    scrubSubscriptionWarnings();
    fixReviewCount();
    hideFakeTestimonials();
    fixReviewStarsAria();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { upgradeProductLcpImg(); runAllScrubbers(); });
  } else {
    upgradeProductLcpImg();
    runAllScrubbers();
  }

  window.addEventListener('cart:updated', function () { setTimeout(runAllScrubbers, 100); });
  window.addEventListener('shopify:section:load', function () { setTimeout(runAllScrubbers, 100); });
  document.addEventListener('variant:change', function () { setTimeout(function () { upgradeProductLcpImg(); runAllScrubbers(); }, 100); });
})();
